import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '../features/auth/views/Login';
import { SelectStoreView } from '../features/auth/views/SelectStoreView';
import { TenantPrivateRoute } from './guards/TenantPrivateRoute';
import { TenantRoute } from './guards/TenantRoute';
import { MainLayout } from '../features/tenant/layout/MainLayout';

export const PartnerRouter: React.FC = () => {
  return (
    <Routes>
      {/* Rutas Públicas de Login */}
      <Route path="/login" element={<Login />} />

      {/* Rutas del Tenant (Protegidas) */}
      <Route element={<TenantPrivateRoute />}>
        <Route path="/select-store" element={<SelectStoreView />} />
        <Route element={<MainLayout />}>
          <Route path="/*" element={<TenantRoute />} />
        </Route>
      </Route>

      {/* Redirección por defecto */}
      <Route path="*" element={<Navigate to="/orders" replace />} />
    </Routes>
  );
};
export default PartnerRouter;
